import React from "react"
import { actionKeys } from "@love-irish/i18n"
import { IconHeadphones } from "@tabler/icons-react"
import BaseListItem from "../base"

export interface AudiobookListItemProps {
  item: Record<string, any>
  className?: string
  /** Custom footer content to replace the default "Added by..." text */
  footer?: React.ReactNode
}

export const AudiobookListItem: React.FC<AudiobookListItemProps> = ({ item, className, footer }) => (
  <BaseListItem
    item={item}
    className={className}
    footer={footer}
    typeIcon={IconHeadphones}
    typeLabel="Audiobook"
    testId="audiobook-list-item"
    readMore={{ useI18n: true, actionKey: actionKeys.LISTEN }}
    media={
      (item.imageUrl || item.thumbnailUrl) && (
        <a href={item.path}>
          <img
            src={item.thumbnailUrl || item.imageUrl}
            alt={item.name}
            className="max-w-[100px] rounded-xl"
          />
        </a>
      )
    }
  />
)

export default AudiobookListItem
